import { child } from "./dom.js";

function svg(parent, inner) {
	parent.innerHTML += `
		<svg viewBox="0 0 264.58333 264.58333" xmlns="http://www.w3.org/2000/svg">
			<g>${inner}</g>
		</svg>`;
}

export function fortyFive(parent) {
	svg(parent, `<path
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		d="m -26.458333,26.458333 h 52.916666 26.458333 c 136.359684,0 158.945264,35.700849 202.228884,79.309907 16.5352,16.65953 37.5233,37.19777 37.5233,37.19777 l 3.50664,161.91786 -140.84259,-0.49901 c 0,0 -29.57595,-27.59459 -37.36901,-36.35891 -5.85679,-6.58673 1.29392,0.32989 -4.71051,-5.39526 C 99.259419,249.28762 86.111621,238.45044 52.916666,238.125 c -33.194957,-0.32544 -79.374999,0 -79.374999,0 z"
	/>`);
}

export function straightCentre(parent) {
	svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="350"
		height="211.66666"
		x="-50"
		y="-238.125"
		transform="rotate(90)"
	/>`);
}

export function straightCorner(parent) {
	svg(parent, `<path
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		d="M -26.458333,26.458333 H 238.125 V 291.04166 H 26.458333 V 238.125 h -52.916666 z"
	/>`);
}

export function diagCentre(parent) {
	svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="211.66666"
		height="411.25946"
		x="-292.92206"
		y="-205.62973"
		transform="rotate(-135)"
	/>`);
}

export function diagCorner(parent) {
	svg(parent, `<rect
		fill="currentColor"
		stroke="#000"
		stroke-width="15"
		width="211.66666"
		height="411.25946"
		x="81.255341"
		y="-392.71851"
		transform="rotate(135)"
	/>`);
}
